import React from 'react';
import { Box, Typography } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';

const EmptyState = ({ 
  icon, 
  title = 'No data found', 
  description, 
  action 
}) => {
  // If icon is a React element, render it directly, otherwise treat it as a component
  const IconComponent = icon || InboxIcon;
  const iconElement = React.isValidElement(icon) ? icon : <IconComponent sx={{ fontSize: 80, color: 'text.disabled' }} />;
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        textAlign: 'center',
        gap: 2,
      }}
    >
      {iconElement}
      <Typography variant="h6" color="text.secondary">
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400 }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </Box>
  );
};

export default EmptyState;
